import Li from "./Li";
import { useGetUserInfo } from "~/hooks/auth/useUserInfo";

export const ClientLinks = () => {
  const { userRole } = useGetUserInfo();
  return <>{userRole === "client" && <Li link="/domains" text="Domains" />}</>;
};
